export default __webpack_public_path__ + "static/media/image.82d351a8.svg";